import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import Cookies from "js-cookie"; 

const ProtectedRoute = () => {
  const accessToken = Cookies.get("access_token"); 
  const isAuthenticated = !!accessToken; 

  return isAuthenticated ? <Outlet /> : <Navigate to="/login" />;
};

export default ProtectedRoute;
